import { formatGodoDate } from "../../../lib/date";

/** Current calendar month in Godo date format for dashboard KPI filters. */
export function currentMonthDashboardRange(): {
  startDate: string;
  endDate: string;
} {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 0, 0);
  return {
    startDate: formatGodoDate(start),
    endDate: formatGodoDate(end),
  };
}
